import store from "../../../store"
import { computed, ComputedRef } from "vue"
export function usePermissionStore() {
  const levelPermissions: ComputedRef<string[]> = computed(
    () => store.getters["member/getCurrentLevelPermissions"]
  )
  const clientPermissions: ComputedRef<string[]> = computed(
    () => store.getters["member/getCurrentClientPermissions"] //store.state.member?.currentMember?.data?.client_permissions ?? []
  )

  const currentClientId: ComputedRef<number> = computed(
    () => store.getters["member/currentClientId"]
  )

  const isCurrentMemberLoaded: ComputedRef<boolean> = computed(
    () => store.getters["member/isCurrentMemberLoaded"]
  )

  if (!isCurrentMemberLoaded.value) {
    store.dispatch("member/getCurrentMember")
  }

  return {
    currentClientId,
    levelPermissions,
    clientPermissions,
  }
}
